// desktop.module.routing.js

"use strict";

//import { desktopIndex } from "./desktop.module.states";

//desktopRouting.$inject = ["$stateProvider"];

function desktopRouting( /*$stateProvider*/) {
  
 // $stateProvider.state(desktopIndex);
  
}

export { desktopRouting };



// WEBPACK FOOTER //
// ./src/components/desktop/desktop.module.routing.js